import { render, staticRenderFns } from "./SurveyDataSummary.vue?vue&type=template&id=54343a72"
import script from "./SurveyDataSummary.vue?vue&type=script&lang=js"
export * from "./SurveyDataSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports